module.exports = __webpack_public_path__ + "media/images/massage/samia@3x-6ae6e9f745a7e2db64422405b58aaf74.jpg";